import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import AuthGate from "./auth/AuthGate";
import Portada from "./components/Portada";
import Finanzas from "./components/Finanzas";
import Canvas from "./components/Canvas";
import Admin from "./components/Admin";
import Preguntas from "./components/Preguntas";

function BackButton() {
  return (
    <Link to="/" style={{
      position: "fixed", top: "12px", left: "12px", zIndex: 1000,
      background: "#ffffffee", color: "#b5836d", textDecoration: "none",
      padding: "6px 12px", borderRadius: "999px",
      border: "1px solid #ebe5df", boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 600,
      backdropFilter: "blur(6px)",
    }}>← Inicio</Link>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthGate>
        {({ user, signOut }) => (
          <Routes>
            <Route path="/" element={<Portada user={user} signOut={signOut} />} />
            <Route path="/finanzas" element={<Finanzas user={user} />} />
            <Route path="/canvas" element={<Canvas />} />
            <Route path="/preguntas" element={<Preguntas user={user} />} />
            <Route path="/admin" element={<Admin user={user} />} />
            <Route path="*" element={<Portada user={user} signOut={signOut} />} />
          </Routes>
        )}
      </AuthGate>
    </BrowserRouter>
  );
}
